import { reduce, keys } from 'ramda';

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var upperFirst = function upperFirst(str) {
  return str.charAt(0).toUpperCase() + str.substr(1);
};
// eslint-disable-next-line
// const isObject = (obj) => Object.prototype.toString.call(obj) === '[object Object]';

var longhand = function longhand(coreProp, prop) {
  return reduce(function (result, key) {
    var k = '' + coreProp + upperFirst(key);
    var v = prop[key];

    // if (isObject(v)) {
    //   return {
    //     ...result,
    //     ...longhand(k, v),
    //   }
    // } else {
    return Object.assign({}, result, defineProperty({}, k, v));
    // }
  }, {}, keys(prop));
};

export default longhand;
